export {
  capitalizeFirstLetter,
  formatPhoneNumber,
  toTitleCase,
} from "./strings";
